/* ============
 * All Product Types
 * ============
 *
 * All product types.
 */

import Vue from 'vue';
import store from './../../store';
import productTypeTransformer from './../../transformers/productType';

const success = ({ data }, resolve) => {
  const productTypes = productTypeTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllProductTypes', productTypes);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display product types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('product_types')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productType/all.js